export const bp = {
  desktop: '1680px',
  desktopSm: '1440px',
  laptop: '1380px',
  laptopSm: '1240px',
  tablet: '1080px',
  portrait: '880px',
  mobile: '767px',
  mobileMid: '625px',
  mobileSm: '580px',
  mobileRealSm: '375px',
  desktopMax: '1679px',
  laptopMax: '1379px',
  laptopSmMax: '1239px',
  tabletMax: '1079px',
  portraitMax: '879px',
  mobileMax: '766px',
  mobileSmMax: '579px',
};

export const hover = val => `
  @media(hover: hover) {
    &:hover {
      ${val}
    }
  }
`;

export const megaText = (size = 4.8) => `
  font-family: "balboa-plus-fill", sans-serif;
  font-size: calc((var(--container)) / ${size});
  line-height: .88;
  letter-spacing: -.05em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

export const inputBorderColor = (props) => {
  if (props.errors) {
    return props.theme.error;
  } else if (props.isDark) {
    return '#fff';
  }
  return props.theme.black;
};

export const hoverSpoofer = el => `
  pointer-events: none;

  ${hover(`
    ${el} {
      &:not(:hover) {
         opacity: 0.3 !important;
      }
    }
  `)}

  ${el} {
    transition: .4s opacity ease-in;
    pointer-events: auto;
  }
`;
